import {
    Compass,
    Users,
    Sparkles,
    Calendar,
    Briefcase,
    GraduationCap,
    MessageSquare,
    HelpCircle,
    Shield,
} from 'lucide-react';
import { PAGES } from 'routes/PAGES';
import { cn } from 'utils/cn';

export const NAV_ICON_MAP = {
    Compass,
    Users,
    Sparkles,
    Calendar,
    Briefcase,
    GraduationCap,
    MessageSquare,
    HelpCircle,
    Shield,
};

export const navSurfaceClass = 'bg-[var(--primary-layer-color)]';
export const navBarClass = 'bg-[var(--navbar-bg)]';
export const navInkClass = 'text-[var(--primary-text-color)]';
export const navMutedClass = 'text-[var(--dark-secondary-color)]';
export const navHairlineClass = 'border-[color:var(--dark-secondary-color)]/20';

export function navIconNameForTo(to, { isHelp } = {}) {
    if (isHelp) {
        return 'HelpCircle';
    }
    const path = String(to || '').split('?')[0];
    if (path === PAGES.MY_COMMUNITIES) return 'Compass';
    if (path === PAGES.PARTICIPANTS) return 'Users';
    if (path === PAGES.CONTACTS) return 'Sparkles';
    if (path === PAGES.EVENT_LIST || (path.startsWith('/event') && path !== '/event/create')) return 'Calendar';
    if (
        path === PAGES.VACANCY_LIST
        || path.startsWith('/job')
        || path.startsWith('/jobs')
        || path.startsWith('/vacancy')
        || path.startsWith('/career')
    ) return 'Briefcase';
    if (path === PAGES.MENTORSHIP) return 'GraduationCap';
    if (path === PAGES.CHATS || path.includes('/chats') || path.includes('/manage-chats')) return 'MessageSquare';
    if (path === PAGES.FAQ) return 'HelpCircle';
    if (path === PAGES.ADMIN || path === PAGES.DASHBOARD || path === PAGES.EVENT || path === PAGES.NOTIFICATIONS) return 'Shield';
    if (path === PAGES.PROFILE || path.startsWith('/u/')) return 'Users';
    return 'Compass';
}

export const NavItemIcon = ({ item, className }) => {
    const name = (item?.icon && NAV_ICON_MAP[item.icon])
        ? item.icon
        : navIconNameForTo(item?.to, { isHelp: item?.isHelp });
    const IconComponent = NAV_ICON_MAP[name] || Compass;
    return <IconComponent className={cn('w-4 h-4', className)} />;
};
